import {
  getAgentFullname,
  getAgentEmail,
  getAgentGuid
} from '../../../lib/access.es6'

// Query-string fragment identifying the acting agent, for the embedded
// group-portal journeys. The portal stamps this onto every policy the agent
// generates. Returns '' for non-agents, so those URLs stay exactly as they were.
export function buildAgentParams() {
  const fullname = getAgentFullname()
  if (!fullname) {
    return ''
  }

  let params = `&agent=${encodeURIComponent(fullname)}`

  const email = getAgentEmail()
  if (email) {
    params += `&agent_email=${encodeURIComponent(email)}`
  }

  const guid = getAgentGuid()
  if (guid) {
    params += `&agent_guid=${encodeURIComponent(guid)}`
  }

  return params
}
